import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { toast, } from 'react-toastify';
// import { getProfileInfo, getSingleUser, updateProfileInfo } from '../../assets/api/super-admin';
import Layout from '../../layouts/layout'
import MainPageLayout from '../../components/main-page-layout/mainPageLayout';
import { useRequestProcessor } from '../../api/requestProcessor';
import { getAdminProfile, updateAdminProfile } from '../../api/profile';

const Setting = () => {

    const { Query, Mutate } = useRequestProcessor()

    const { data, isLoading, isError } = Query(
        ['getAdminProfile'],
        () => getAdminProfile(),
    );

    const { mutate: mutateAdminProfile } = Mutate(
        "updateAdminProfile",
        updateAdminProfile,
        {
            onSuccess: (data) => {
                onSuccessHandler(data) //This is the response you get back
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    );

    const navigate = useNavigate()

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm();


    function onSuccessHandler(res) {
        toast.success(res.message, {
            autoClose: 3000
        })
        toast.info(" تا 3 ثانیه دیگر منتقل خواهید شد", {
            autoClose: 3000
        })
        setTimeout(() => { navigate("/super-admin/dashboard") }, 2900)
    }


    async function onSubmitHandler(data) {
        const { password, confirm_password, lastname, name, phone, email, ...restData } = data;

        if (password === confirm_password) {
            mutateAdminProfile({
                name: name,
                lastname:lastname,
                password: password,
                email: email,
                phone: phone
            })
        }
        else {
            toast.error("پسورد با هم تطابق ندارد")
        }
    }



    useEffect(() => {
        reset(data?.data);
    }, [data]);


    return (
        <Layout>
            <MainPageLayout backButton title={"ویرایش اطلاعات"} sectionTitle={"ویرایش اطلاعات کاربری"} >
                <form onSubmit={handleSubmit(data => onSubmitHandler(data))} className='flex flex-col'>
                    <div className='flex flex-col my-4'>
                        <div className='flex flex-col my-3'>
                            <p className='pr-3 pb-1'>نام :</p>
                            <input {...register("name", { required: true })} type="text" className='form-input wsm:!w-full' placeholder='نام و نام خانوادگی' />
                        </div>
                        <div className='flex flex-col my-3'>
                            <p className='pr-3 pb-1'>نام خانوادگی :</p>
                            <input {...register("lastname", { required: true })} type="text" className='form-input wsm:!w-full' placeholder='نام و نام خانوادگی' />
                        </div>
                        <div className='flex flex-col my-3'>
                            <p className='pr-3 pb-1'>ایمیل:</p>
                            <input {...register("email", { required: true })} type="email" className='form-input wsm:!w-full' placeholder='ایمیل' />
                        </div>
                        <div className='flex flex-col my-3'>
                            <p className='pr-3 pb-1'>شماره تلفن:</p>
                            <input {...register("phone", { required: true })} type="number" className='form-input wsm:!w-full' placeholder='شماره تلفن' />
                        </div>
                        <div className='flex flex-col my-3'>
                            <p className='pr-3 pb-1'>پسورد جدید :(اختیاری)</p>
                            <input {...register("password")} type="text" className='form-input wsm:!w-full' placeholder='پسورد جدید ' />
                        </div>
                        <div className='flex flex-col my-3'>
                            <p className='pr-3 pb-1'>تایید پسورد جدید :(اختیاری)</p>
                            <input {...register("confirm_password")} type="text" className='form-input wsm:!w-full' placeholder='تایید پسورد جدید' />
                        </div>
                    </div>
                    <div id='form-add-button--container'>
                        <button type="submit" className='wsm:!w-full' id='form-add-button'>ویرایش تغییرات</button>
                    </div>
                </form>
            </MainPageLayout>
        </Layout>
    )
}

export default Setting